import { pipe, Option, Array as A } from 'effect';

// The virtualized listbox renders an option's `src` as an avatar; `logo_url` is copied there.

type LogoCarrier = { logo_url?: string };

export const getOptionLogo = (option: unknown): Option.Option<string> =>
  pipe(
    Option.fromNullable(option),
    Option.filter((value): value is LogoCarrier => typeof value === 'object'),
    Option.flatMap((value) => Option.fromNullable(value.logo_url)),
    Option.filter((url) => url.length > 0),
  );

// Function declarations: esbuild-loader parses .ts as TSX, where `<T>() =>` is JSX.
export function hasOptionLogos<T>(options: ReadonlyArray<T>): boolean {
  return pipe(
    options,
    A.some((option) => Option.isSome(getOptionLogo(option))),
  );
}

export function withLogoSrc<T extends object>(options: ReadonlyArray<T>): Array<T & { src?: string }> {
  return pipe(
    options,
    A.map((option) =>
      pipe(
        getOptionLogo(option),
        Option.match({
          onNone: () => option,
          onSome: (src) => ({ ...option, src }),
        }),
      ),
    ),
  );
}
